module.exports = __webpack_public_path__ + "static/media/Step5.08f195a2.svg";